"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseTechnologies = exports.BuildingSpecifications = exports.WarehouseCertifications = exports.WarehouseCapabilities = void 0;
var WarehouseCapabilities;
(function (WarehouseCapabilities) {
    WarehouseCapabilities["AmazonFBA"] = "Amazon FBA";
    WarehouseCapabilities["AmazonFBM"] = "Amazon FBM";
    WarehouseCapabilities["BarcodeScanning"] = "Barcode Scanning";
    WarehouseCapabilities["BulkBagging"] = "Bulk Bagging";
    WarehouseCapabilities["CartonLabelling"] = "Carton Labelling";
    WarehouseCapabilities["CartonPick"] = "Carton Pick";
    WarehouseCapabilities["CFS"] = "CFS";
    WarehouseCapabilities["CrossDock"] = "Cross-Dock";
    WarehouseCapabilities["Devanning"] = "Devanning";
    WarehouseCapabilities["Drayage"] = "Drayage";
    WarehouseCapabilities["DrumFilling"] = "Drum Filling";
    WarehouseCapabilities["EDIUCC128Compliance"] = "EDI/UCC-128 Compliance";
    WarehouseCapabilities["FDACertification"] = "FDA Certified";
    WarehouseCapabilities["Frozen"] = "Frozen";
    WarehouseCapabilities["GarmentHandling"] = "Garment Handling";
    WarehouseCapabilities["HazMat"] = "Haz-Mat";
    WarehouseCapabilities["Kitting"] = "Kitting";
    WarehouseCapabilities["Labeling"] = "Labeling";
    WarehouseCapabilities["LessThanTruckload"] = "LTL";
    WarehouseCapabilities["PalletRebuild"] = "Pallet Rebuild";
    WarehouseCapabilities["Palletization"] = "Palletization";
    WarehouseCapabilities["PickAndPack"] = "Pick And Pack";
    WarehouseCapabilities["PickupAndDelivery"] = "Pickup And Delivery";
    WarehouseCapabilities["Pricelabelling"] = "Price Labelling";
    WarehouseCapabilities["Reworks"] = "Re-works";
    WarehouseCapabilities["Refrigerated"] = "Refrigerated";
    WarehouseCapabilities["Repacking"] = "Repacking";
    WarehouseCapabilities["SellerFulfilledPrime"] = "Seller Fulfilled Prime";
    WarehouseCapabilities["ShippingLabelling"] = "Shipping Labelling";
    WarehouseCapabilities["Storage"] = "Storage";
    WarehouseCapabilities["TransportationManagementSystemSoftware"] = "Transportation Management System Software";
    WarehouseCapabilities["DockSchedulingSoftware"] = "Dock Scheduling Software";
})(WarehouseCapabilities = exports.WarehouseCapabilities || (exports.WarehouseCapabilities = {}));
var WarehouseCertifications;
(function (WarehouseCertifications) {
    WarehouseCertifications["Aib"] = "AIB Certification";
    WarehouseCertifications["Alcohol"] = "Alcohol Certified";
    WarehouseCertifications["Bonded"] = "Bonded";
    WarehouseCertifications["Ctpat"] = "C-TPAT Member";
    WarehouseCertifications["Foodgrade"] = "Food Grade";
    WarehouseCertifications["ForeignTrade"] = "Foreign Trade Zone";
    WarehouseCertifications["Hazmat"] = "Hazmat";
    WarehouseCertifications["Organic"] = "Organic";
    WarehouseCertifications["Tsa"] = "TSA Certified";
})(WarehouseCertifications = exports.WarehouseCertifications || (exports.WarehouseCertifications = {}));
var BuildingSpecifications;
(function (BuildingSpecifications) {
    BuildingSpecifications["SecuritySystem"] = "Security System";
    BuildingSpecifications["VideoSurveillance"] = "Video Surveillance";
    BuildingSpecifications["Gates"] = "Gates";
    BuildingSpecifications["OnSiteSecurity"] = "On Site Security";
})(BuildingSpecifications = exports.BuildingSpecifications || (exports.BuildingSpecifications = {}));
var WarehouseTechnologies;
(function (WarehouseTechnologies) {
    WarehouseTechnologies["ThreePLWarehouseManager"] = "Extensiv";
    WarehouseTechnologies["Camelot"] = "Camelot";
    WarehouseTechnologies["ChannelApe"] = "ChannelApe";
    WarehouseTechnologies["DaVinci"] = "Da Vinci";
    WarehouseTechnologies["Daytexfootprint"] = "Daytex/footprint";
    WarehouseTechnologies["Deposco"] = "Deposco";
    WarehouseTechnologies["Flowspace"] = "Flowspace";
    WarehouseTechnologies["FreightPOP"] = "FreightPOP";
    WarehouseTechnologies["Fulcrum"] = "Fulcrum";
    WarehouseTechnologies["HighJump"] = "High Jump";
    WarehouseTechnologies["Korber"] = "Korber";
    WarehouseTechnologies["LogisticallyTMS"] = "Logistically TMS";
    WarehouseTechnologies["Logiwa"] = "Logiwa";
    WarehouseTechnologies["ManhattanSCALE"] = "Manhattan SCALE";
    WarehouseTechnologies["RedPrairie"] = "Red Prairie";
    WarehouseTechnologies["ShipBob"] = "ShipBob";
    WarehouseTechnologies["ShipEdge"] = "ShipEdge";
    WarehouseTechnologies["Shipwell"] = "Shipwell";
    WarehouseTechnologies["Windfall"] = "Windfall";
    WarehouseTechnologies["Other"] = "Other";
})(WarehouseTechnologies = exports.WarehouseTechnologies || (exports.WarehouseTechnologies = {}));
